module.exports = __webpack_public_path__ + "img/check-circle-fill-green.213e63a9.svg";